import React, { useState, useEffect } from "react";
import SchoolHeader from "../components/SchoolHeader";
import Footer from "../components/Footer";
import HospitalHeader from "../components/HospitalHeader";
import moment from "moment"
import { Container, Card, Row, Col } from "react-bootstrap";
import { DataGrid } from "@mui/x-data-grid";
import { Modal } from "react-bootstrap";
import { Form, Button } from "react-bootstrap";
import { FaEye, FaFolder } from "react-icons/fa";
import schoolServices from "../services/school_services";
import { useParams } from "react-router-dom";
import hospitalServices from "../services/hospital.services";
import Dropdown from 'react-bootstrap/Dropdown';
import { getSchoolSharedDoc, showSuccessMessage } from "../services/utils";
import { Link } from "react-router-dom";
import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers";
import LoadingBar from "../components/common-components/toaster/loader/loader";
import { getHospitalSharedDoc } from "../services/utils";
const SchoolFiles = () => {
    const role = localStorage.getItem("PageTittle")
    const param = useParams()
    const [fileName, setFileName] = useState();
    const [folderName, setFolderName] = useState({})
    const [folderData, setFolderData] = useState([])
    const [rows, setRows] = useState([])
    const [allFolders, setFolders] = useState([])
    const [fileOpen, setFileOpen] = useState({ isFileOpen: false, isFolderOpen: false })
    const [loadin, Setloading] = useState(false)
    const columns = [
        { field: "showName", headerName: "File Name", width: 300 },
        { field: "size", headerName: "File Size", width: 300 },
        { field: "createdAt", headerName: "Created On", width: 200 },
        { field: "expiration_time", headerName: "Expired On", width: 200 },
        {
            field: "action",
            headerName: "Action",
            sortable: false,
            width: 150,
            renderCell: (params) => {

                return (
                    <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            Setloading(true)
                            if (role === 'Hospital') {
                                getHospitalSharedDoc({
                                    document: params.row.name,
                                    type: "cstm_file"
                                }).then(resp => {
                                    Setloading(false)
                                }).catch(err => {
                                    Setloading(false)
                                })
                            } else {
                                getSchoolSharedDoc({
                                    document: params.row.name,
                                    type: "cstm_file"
                                }).then(resp => {
                                    Setloading(false)
                                }).catch(err => {
                                    Setloading(false)
                                })
                            }

                        }
                        }
                    >
                        <span className="actn_icn">
                            <FaEye title="Preview" />
                        </span>
                        {/* <span className="actn_icn">
                            <FaShare title="Share" />
                        </span>
                        <span className="actn_icn">
                            <FaTrashAlt title="Delete" />
                        </span> */}
                    </div>
                );
            },
        },
    ];

    const getSchoolFolderData = (folder_Id) => {
        Setloading(true)
        setRows([])
        setFolders([])
        if (role === "School") {
            schoolServices.getSharedFilesUnderFolder(folder_Id).then(resp => {
                resp && resp.data && resp.data.list.map((curr, index) => {
                    curr.id = curr._id
                    curr.size = curr.size + " kb"
                    curr.createdAt = moment(curr.createdAt).format("MM-DD-YYYY")
                    curr.expiration_time = curr.expiration_time ? moment(curr.expiration_time).format("MM-DD-YYYY") : "N/A"
                    if (curr.name.indexOf("-") != -1) {
                        curr.showName = curr.name.substring(0, curr.name.indexOf("-"))
                    }
                    else {
                        curr.showName = curr.name
                    }

                    if (curr.type === 'file') {
                        setRows(oldRow => ([curr, ...oldRow]))
                    }
                    if (curr.type === 'folder') {
                        setFolders(oldRow => ([curr, ...oldRow]))
                    }
                })
                setFolderData(resp.data.folderData)
                Setloading(false)
            }).catch(err => Setloading(false))
        }

        else if (role === "Hospital") {
            hospitalServices.getHospitalSharedFiles(folder_Id).then(resp => {
                resp && resp.list.map((curr, index) => {
                    curr.id = curr._id
                    curr.size = curr.size + " kb"
                    curr.createdAt = moment(curr.createdAt).format("MM-DD-YYYY")
                    curr.expiration_time = curr.expiration_time ? moment(curr.expiration_time).format("MM-DD-YYYY") : "N/A"
                    if (curr.name.indexOf("-") != -1) {
                        curr.showName = curr.name.substring(0, curr.name.indexOf("-"))
                    }
                    else {
                        curr.showName = curr.name
                    }

                    if (curr.type === 'file') {
                        setRows(oldRow => ([curr, ...oldRow]))
                    }
                    if (curr.type === 'folder') {
                        setFolders(oldRow => ([curr, ...oldRow]))
                    }
                })
                setFolderData(resp.folderData)
                Setloading(false)
            }).catch(err => Setloading(false))
        }
    }

    const createFile = async (data) => {
        const fileData = new FormData();
        for (var key in data) {
            fileData.append(key, data[key])
        }

        if (role === "Hospital") {
            await hospitalServices.createFileFolder(fileData).then((resp) => {
                showSuccessMessage({ message: "Created successfully" })
                getSchoolFolderData(param.folderId)
            })
        } else {
            await schoolServices.createFileFolder(fileData).then((resp) => {
                showSuccessMessage({ message: "Created successfully" })
                getSchoolFolderData(param.folderId)
            })
        }

    }

    useEffect(() => {
        getSchoolFolderData(param.folderId)
    }, [param.folderId])


    return (
        <div className="dashbrd_pg">
            {role === "School" ?
                <SchoolHeader />
                :
                <HospitalHeader />
            }

            <div className="schl_prfl_pg">
                <Container className="custm_container">
                    {loadin &&
                        <LoadingBar />
                    }
                    <div className="prfl_wrap">
                        <div className="pg_hdng mb-4 db-sub-btn">
                            <h2>{folderData && folderData.name}</h2>
                            {
                                param.createdBy_id &&
                                <div className="db-sub-btn">
                                    <div style={{ marginLeft: "10px" }}>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="" className="btn_theme" id="dropdown-basic">
                                                +Create Document
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => { setFileOpen({ ...fileOpen, isFileOpen: !fileOpen.isFileOpen }) }}>File</Dropdown.Item>
                                                <Dropdown.Item onClick={() => { setFileOpen({ ...fileOpen, isFolderOpen: !fileOpen.isFolderOpen }) }}>Folder</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>

                                </div>
                            }

                        </div>
                        <Row>
                            <Col sm={12}>
                                <Card className="pg_card">
                                    <Card.Body>
                                        <div className="files_cards">
                                            <Row>
                                                {
                                                    allFolders && allFolders.length > 0 && allFolders.map(curr => {
                                                        return (

                                                            <Col sm="3">
                                                                <Link
                                                                    to={param.createdBy_id ? `/school-files/${curr._id}/${param.createdBy_id}` : `/school-files/${curr._id}`}
                                                                    style={{
                                                                        paddingRight: "15px",
                                                                        color: "#164baf",
                                                                    }}
                                                                >
                                                                    <div className="file_card mb-3">
                                                                        <div className="fldr_icn txt_prpl">
                                                                            <FaFolder />
                                                                        </div>
                                                                        <h5>
                                                                            {curr.name}
                                                                        </h5>
                                                                    </div>

                                                                </Link>

                                                            </Col>
                                                        )
                                                    })
                                                }

                                            </Row>
                                        </div>
                                    </Card.Body>
                                </Card>
                                <Card className="pg_card">
                                    <Card.Body>
                                        <div className="card_hdng">
                                            <h4 className="mb-0">
                                                Files
                                            </h4>
                                        </div>
                                        <div className="apprvl_list">
                                            <div
                                                style={{
                                                    height: 400,
                                                    width: "100%",
                                                }}
                                            >
                                                <DataGrid
                                                    rows={rows}
                                                    columns={columns}
                                                    pageSize={5}
                                                    rowsPerPageOptions={[5]}
                                                />
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                    <Modal show={fileOpen.isFileOpen} onHide={() => { setFileOpen({ ...fileOpen, isFileOpen: !fileOpen.isFileOpen }) }} className="main_modl">
                        <Modal.Header closeButton>
                            <Modal.Title className="text_theme">
                                Create New File
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="prfl_flds">
                                <Form>
                                    <Form.Group controlId="formFile" className="mb-3">
                                        <Form.Label> Add New File</Form.Label>
                                        <Form.Control
                                            type="file"
                                            fullWidth
                                            name="file"
                                            required
                                            placeholder="Enter Department's Name"
                                            onChange={(e) => {
                                                setFileName({
                                                    ...fileName,
                                                    "name": e.target.files[0],
                                                    "parent_id": param.folderId,
                                                    "type": "file",
                                                    "createdBy_id": param.createdBy_id

                                                })
                                                // const fileData = new FormData();
                                                // fileData.append("name", e.target.files[0]);
                                                // fileData.append("type", "file");
                                                // fileData.append("parent_id", param.folderId);
                                                // fileData.append("createdBy_id", param.createdBy_id);
                                                // setFileName(fileData);
                                            }}
                                        />
                                    </Form.Group>


                                    <Form.Group
                                        controlId="formFile"
                                        className=" mui_dtpickr"
                                    >

                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                            <Form.Label>
                                                Expiration Date (optional)
                                            </Form.Label>

                                            <DatePicker
                                                placeholder="Enter Graduation Date"
                                                className="form-control"
                                                value={fileName?.expiration_time ? fileName?.expiration_time : null}
                                                onChange={(
                                                    newValue

                                                ) => {
                                                    if (newValue&&newValue._d) {
                                                        setFileName({
                                                            ...fileName,
                                                            "expiration_time": newValue._d,
                                                        })
                                                        // fileData.append("expiration_date", newValue._d);
                                                        // setFileName(fileData)
                                                    }

                                                }}


                                                renderInput={(
                                                    params
                                                ) => (
                                                    <TextField
                                                        {...params}
                                                        required
                                                    />
                                                )}
                                            />
                                        </LocalizationProvider>
                                    </Form.Group>

                                    <Form.Group
                                        controlId="formFile"
                                        className="mb-3 mui_dtpickr"
                                    >

                                    </Form.Group>
                                    <div className="text-center">
                                        <Button
                                            className="btn_theme mt-4"
                                            variant=""
                                            onClick={async (e) => {
                                                await createFile(fileName).then(res => setFileOpen({ ...fileOpen, isFileOpen: !fileOpen.isFileOpen }))

                                            }}
                                        >
                                            Create
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </Modal.Body>
                    </Modal>

                    <Modal show={fileOpen.isFolderOpen} onHide={() => { setFileOpen({ ...fileOpen, isFolderOpen: !fileOpen.isFolderOpen }) }} className="main_modl">
                        <Modal.Header closeButton>
                            <Modal.Title className="text_theme">
                                Create New Folder
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="prfl_flds">
                                <Form>
                                    <Form.Group controlId="formFile" className="mb-3">
                                        <Form.Label> Add New Folder</Form.Label>
                                        <Form.Control
                                            type="text"
                                            fullWidth
                                            name="file"
                                            placeholder="Enter Folder's Name"
                                            onChange={(e) => {
                                                setFolderName({
                                                    name: e.target.value,
                                                    type: "folder",
                                                    parent_id: param.folderId,
                                                    createdBy_id: param.createdBy_id
                                                });
                                            }}
                                        />
                                    </Form.Group>

                                    <Form.Group
                                        controlId="formFile"
                                        className="mb-3 mui_dtpickr"
                                    >

                                    </Form.Group>
                                    <div className="text-center">
                                        <Button
                                            className="btn_theme mt-4"
                                            variant=""
                                            onClick={async (e) => {
                                                await createFile(folderName).then(res => setFileOpen({ ...fileOpen, isFolderOpen: !fileOpen.isFolderOpen }))

                                            }}
                                        >
                                            Create
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </Modal.Body>
                    </Modal>
                </Container>
            </div>
            <Footer />
        </div>
    );
};

export default SchoolFiles;
